import React from "react";
import { Link } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import { useAdminContext } from "../../../context/admin/context/AdminContext";

export const GoBack = ({ props }) => {
  const { singleAdmin, setSingleAdmin } = useAdminContext();
  const isBackToMain = String(props?.route) === "/dosee/data" && singleAdmin;

  const target = isBackToMain ? singleAdmin?.route : props?.route;
  const label = props?.label || "Go Back";

  return (
    <div className="sticky top-0 z-[99] w-full bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-gray-100">
      <div className="mx-auto max-w-7xl px-3 sm:px-4 py-2.5">
        <Link
          to={target}
          onClick={() => {
            if (isBackToMain) setSingleAdmin(null);
          }}
          aria-label={label}
          className="group inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3.5 py-2 text-gray-800 shadow-sm transition hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
        >
          <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-gray-900 text-white shadow-sm transition group-hover:translate-x-[-1px]">
            <MdArrowBackIosNew className="text-[13px]" aria-hidden="true" />
          </span>
          <span className="text-xs font-semibold tracking-wide">{label}</span>
        </Link>
      </div>
    </div>
  );
};

/**
 * GoBackTool — visual-only refresh
 * - Same API (route)
 */
export const GoBackTool = ({ route, label = "Go Back" }) => {
  return (
    <div className="sticky top-0 z-[99999] w-full bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-gray-100">
      <div className="mx-auto max-w-7xl px-3 sm:px-4 py-2.5">
        <Link
          to={route}
          aria-label={label}
          className="group inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3.5 py-2 text-gray-800 shadow-sm transition hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
        >
          <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-gray-900 text-white shadow-sm transition group-hover:translate-x-[-1px]">
            <MdArrowBackIosNew className="text-[13px]" aria-hidden="true" />
          </span>
          <span className="text-xs font-semibold tracking-wide">{label}</span>
        </Link>
      </div>
    </div>
  );
};
